/* unplugin-vue-components disabled */import script from "./BaseImageFallback.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseImageFallback.vue?vue&type=script&setup=true&lang=js"

import "./BaseImageFallback.vue?vue&type=style&index=0&id=5027b7c6&lang=scss"

export default script